import { render } from "./belajar_tagbox.vue?vue&type=template&id=35bba411"
import script from "./belajar_tagbox.vue?vue&type=script&lang=js"
export * from "./belajar_tagbox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__